import { Paging } from '@csp/dmdp-api-common-dto';
import { AppointmentsV1 } from '@csp/dmdp-api-appointment-dto';
import { BookedVisit } from './BookedVisit';

export type BookedVisitsPage = {
  paging: Paging;
  visits: BookedVisit[];
};

const from = ({ paging, appointments }: AppointmentsV1): BookedVisitsPage => ({
  paging,
  visits: appointments.map(BookedVisit.from),
});

export const BookedVisitsPage = { from };
